import React from 'react';

interface IProps {
  children?: React.ReactNode | React.ReactNode[];
}

export const ModalFooter = (props: IProps) => (
  <div className="bg-lake-fog rounded-b-md p-6" {...props} />
);
